import { action } from '@play-co/replicant';
import createActions from '../config/actions/createActions';
import { AccessoryItemID, AccessoryTierID } from './accessory.ruleset';
import {
  equipAccessoryItem,
  markAccessoryItemsAsSeen,
  unequipAllAccessoryItems,
} from './accessory.modifiers';
import { getAccessoryItem, isAccessoryPurchased } from './accessory.getters';

export const accessoryActions = createActions({
  /**
   * Equip accessory items
   */
  equipAccessoryItems: action(
    (
      state,
      args: {
        items: { itemId: AccessoryItemID; tierId: AccessoryTierID }[];
      },
    ) => {
      const { items } = args;

      // Clear all selected items
      unequipAllAccessoryItems(state);

      for (const { itemId, tierId } of items) {
        const item = getAccessoryItem(itemId);
        if (!item)
          throw new Error(`Accessory item ${itemId} not found in config`);

        const isPurchased = isAccessoryPurchased(state, itemId);

        // If item cost money but not purchased throw error
        if (!isPurchased) {
          throw new Error(`Accessory item ${itemId} was not purchased`);
        }

        // Equip if item already purchased or free
        equipAccessoryItem(state, itemId, item.slot, tierId);
      }
    },
  ),

  /**
   * Mark all accessory items as seen.
   */
  markAccessoryItemsAsSeen: action((state) => {
    markAccessoryItemsAsSeen(state);
  }),
});
